module.exports = __webpack_public_path__ + "static/media/enggCourses.81c89771.jpg";